$(document).ready(function(){

    let subs = document.getElementsByClassName('sub-tag')

    // card-product.liquid only emits .sub-tag on the FOC collection
    // (collection.title == "FOC") and for curIncv cards, but this script
    // loads on every main-collection-product-grid. Bail on other
    // collections instead of dereferencing subs[0] === undefined.
    if (subs.length === 0) return

    getSubsLists(subs[0].dataset.custemail)
    
})

async function getSubsLists(email) {
       
          var sentPkg = {customerEmail: email}
          var html = "https://ecgce-backend.uzairkhan.workers.dev/api/subscriptions/list";


          await fetch(html, 
            {
                method: "post",
                credentials: "omit",  
                body: JSON.stringify(sentPkg), 
                cache: "no-cache", 
                headers: new Headers({"content-type": "application/json"})
          
          })
          
          .then(function(response) {
                  
                  console.log(response)
                  
                  if (response.status !== 200) {
                      console.log('Response status was not 200: $(response.status)')
                      return ;
                  }

                  response.json().then(function(data) {
                      
                    let subsList = data['seriesSubs'];
                   
                    document.querySelectorAll('.sub-tag').forEach(element => {
                        let eleSeries = element.dataset.series;
                        console.log(eleSeries)
                        if (subsList.includes(eleSeries)){
                            element.textContent = "Subbed";
                            element.classList.add('subbed');
                        }
                        else {
                            element.textContent = "Unsubbed";
                        }
                        
                    
                    })
                  
                      
                                      

                  })
          
          });
          
        }